(() => {
  const option = (value, icon, label, note) => [value, icon, label, note];

  const OCCASION = {
    id: 'occasion',
    title: 'Na jaką okazję szukasz prezentu?',
    subtitle: 'Wybierz moment. Za chwilę zapytamy już tylko o właściwą osobę.',
    options: [
      option('boy_day', '01', 'Dzień Chłopaka', 'Dla partnera albo dobrego kumpla'),
      option('birthday', '🎂', 'Urodziny', 'Prezent z efektem WOW'),
      option('valentines', '♥', 'Rocznica lub Walentynki', 'Coś osobistego dla Waszej dwójki'),
      option('family_day', '⌂', 'Dzień Mamy, Taty lub Dziadków', 'Prezent dopasowany do konkretnej osoby'),
      option('christmas', '✶', 'Święta lub inna okazja', 'Pod choinkę, na podziękowanie albo bez okazji')
    ]
  };

  const RELATIONSHIPS = {
    partner_male: option('partner_male', '♥', 'Chłopak lub mąż', 'Tylko prezenty pasujące do niego'),
    partner_female: option('partner_female', '♥', 'Dziewczyna lub żona', 'Tylko prezenty pasujące do niej'),
    dad: option('dad', 'T', 'Tata', 'Produkty stworzone specjalnie dla taty'),
    mom: option('mom', 'M', 'Mama', 'Produkty stworzone specjalnie dla mamy'),
    grandpa: option('grandpa', 'D', 'Dziadek', 'Tylko prezenty dla dziadka'),
    grandma: option('grandma', 'B', 'Babcia', 'Tylko prezenty dla babci'),
    child: option('child', '★', 'Dziecko', 'Produkty dziecięce, bez prezentów dla dorosłych'),
    baby: option('baby', '☁', 'Niemowlę lub maluch', 'Pamiątki i prezenty dla najmłodszych'),
    male_friend: option('male_friend', '☺', 'Kolega lub przyjaciel', 'Zabawny prezent dla niego'),
    female_friend: option('female_friend', '☺', 'Przyjaciółka lub koleżanka', 'Prezent w jej klimacie'),
    couple_family: option('couple_family', '♡', 'Para', 'Wspólne imiona, zdjęcie albo data'),
    whole_family: option('whole_family', '∞', 'Cała rodzina', 'Jeden prezent z rodzinną historią')
  };

  const GROUP_OPTIONS = {
    partner: option('partner', '♥', 'Partner lub partnerka', 'Za chwilę wybierzesz konkretną osobę'),
    family: option('family', '⌂', 'Mama, tata lub dziadkowie', 'Każda z tych osób ma osobną kategorię'),
    kids: option('kids', '★', 'Dziecko lub niemowlę', 'Osobne propozycje dla dziecka i malucha'),
    others: option('others', '☺', 'Przyjaciele, para lub rodzina', 'Wybierzemy dokładną relację w następnym kroku')
  };

  const GROUPS_BY_OCCASION = {
    boy_day: ['partner_male', 'male_friend'],
    valentines: ['partner_male', 'partner_female', 'couple_family'],
    family_day: ['mom', 'dad', 'grandma', 'grandpa'],
    birthday: ['partner', 'family', 'kids', 'others'],
    christmas: ['partner', 'family', 'kids', 'others']
  };

  const EXACT_BY_GROUP = {
    partner: ['partner_male', 'partner_female'],
    family: ['mom', 'dad', 'grandma', 'grandpa'],
    kids: ['child', 'baby'],
    others: ['male_friend', 'female_friend', 'couple_family', 'whole_family']
  };

  const PROFILE_OPTIONS = {
    tech_moto: option('tech_moto', '⚙', 'Gry, auta i majsterkowanie', 'Techniczny klimat i konkretne hobby'),
    sport_chill: option('sport_chill', '●', 'Sport i dobry chill', 'Aktywnie albo spokojnie przy ulubionym hobby'),
    pet_adventure: option('pet_adventure', '🐾', 'Pupil i wspólne przygody', 'Zdjęcie zwierzaka, wyjazdy i dobre historie'),
    style_relax: option('style_relax', '✿', 'Styl i małe przyjemności', 'Kawa, dodatki i domowy relaks'),
    family_story: option('family_story', '⌂', 'Rodzina i wspomnienia', 'Imiona, zdjęcia i ważne chwile'),
    garden_home: option('garden_home', '❀', 'Dom, ogród i spokój', 'Kwiaty, kawa i codzienne przyjemności'),
    gaming: option('gaming', '+', 'Gaming', 'Komputer, konsola i internetowy klimat'),
    sport: option('sport', '●', 'Sport', 'Boisko, rower, siłownia albo kibicowanie'),
    kids_fun: option('kids_fun', '★', 'Kolorowy dziecięcy świat', 'Bajki, potworki i wesołe motywy'),
    cute_memory: option('cute_memory', '☁', 'Słodka pamiątka', 'Delikatny motyw i ważny rodzinny moment'),
    shared_story: option('shared_story', '▣', 'Wasza wspólna historia', 'Zdjęcia, daty i teksty z Waszego życia'),
    humor: option('humor', '☺', 'Przede wszystkim dobra beka', 'Ma zobaczyć prezent i od razu się roześmiać')
  };

  const PROFILE_KEYS = {
    partner_male: ['tech_moto', 'sport_chill', 'pet_adventure', 'shared_story'],
    partner_female: ['style_relax', 'sport_chill', 'pet_adventure', 'shared_story'],
    dad: ['tech_moto', 'sport_chill', 'family_story', 'humor'],
    mom: ['family_story', 'style_relax', 'garden_home', 'humor'],
    grandpa: ['family_story', 'sport_chill', 'garden_home', 'humor'],
    grandma: ['family_story', 'garden_home', 'pet_adventure', 'humor'],
    child: ['gaming', 'sport', 'kids_fun', 'pet_adventure'],
    baby: ['cute_memory', 'family_story', 'pet_adventure', 'humor'],
    male_friend: ['tech_moto', 'sport_chill', 'pet_adventure', 'humor'],
    female_friend: ['style_relax', 'sport_chill', 'pet_adventure', 'shared_story'],
    couple_family: ['shared_story', 'family_story', 'pet_adventure', 'humor'],
    whole_family: ['family_story', 'shared_story', 'pet_adventure', 'humor']
  };

  const MOOD_OPTIONS = {
    laugh: option('laugh', '☺', 'Ma paść ze śmiechu', 'Najważniejsza jest reakcja przy otwieraniu'),
    romantic: option('romantic', '♥', 'Ma być bardzo osobisty', 'Wasza historia w formie prezentu'),
    sentimental: option('sentimental', '◌', 'Ma wzruszyć', 'Imiona, zdjęcie albo ważne wspomnienie'),
    practical: option('practical', '✓', 'Ma bawić i przydawać się', 'Prezent, który zostanie na dłużej'),
    bold: option('bold', '!', 'Ma zrobić mocne WOW', 'Widoczny nadruk i duży efekt')
  };

  const MOOD_KEYS = {
    partner_male: ['laugh', 'romantic', 'bold'],
    partner_female: ['laugh', 'romantic', 'sentimental'],
    dad: ['laugh', 'sentimental', 'practical'],
    mom: ['sentimental', 'laugh', 'practical'],
    grandpa: ['sentimental', 'laugh', 'practical'],
    grandma: ['sentimental', 'laugh', 'practical'],
    child: ['laugh', 'bold', 'practical'],
    baby: ['sentimental', 'laugh', 'practical'],
    male_friend: ['laugh', 'bold', 'practical'],
    female_friend: ['laugh', 'bold', 'sentimental'],
    couple_family: ['romantic', 'sentimental', 'laugh'],
    whole_family: ['sentimental', 'laugh', 'practical']
  };

  const INTEREST_SIGNALS = {
    tech_moto: ['gaming', 'cars', 'diy'],
    sport_chill: ['sport', 'fishing_beer', 'coffee'],
    pet_adventure: ['petlover', 'party_travel'],
    style_relax: ['beauty_style', 'coffee', 'garden'],
    family_story: ['family', 'no_preference'],
    garden_home: ['garden', 'coffee', 'family'],
    gaming: ['gaming'],
    sport: ['sport'],
    kids_fun: ['kids_fun'],
    cute_memory: ['family', 'no_preference'],
    shared_story: ['no_preference', 'family'],
    humor: ['no_preference']
  };

  const COLLECTIONS = {
    partner_male: ['Zobacz wszystkie prezenty dla chłopaka', 'collections/prezent-na-dzien-chlopaka'],
    partner_female: ['Zobacz wszystkie prezenty dla dziewczyny', 'collections/koszulki-dla-dziewczyny'],
    dad: ['Zobacz wszystkie prezenty dla taty', 'collections/prezent-na-dzien-ojca'],
    mom: ['Zobacz wszystkie prezenty dla mamy', 'collections/prezent-na-dzien-mamy'],
    grandpa: ['Zobacz prezenty dla dziadka', 'collections/koszulki-dla-dziadka'],
    grandma: ['Zobacz prezenty dla babci', 'collections/koszulki-dla-babci'],
    child: ['Zobacz wszystkie prezenty dla dzieci', 'collections/prezent-dla-dzieci'],
    baby: ['Zobacz prezenty dla niemowlaka', 'collections/prezent-dla-niemowlaka'],
    male_friend: ['Zobacz prezenty dla przyjaciela', 'collections/koszulka-dla-przyjaciela'],
    female_friend: ['Zobacz prezenty dla przyjaciółki', 'collections/koszulki-dla-przyjaciolki'],
    couple_family: ['Zobacz prezenty dla par', 'collections/koszulki-dla-par'],
    whole_family: ['Zobacz prezenty dla rodziny', 'collections/koszulki-dla-rodziny']
  };

  const LIVE_PRODUCTS_SECTION = 'egifts-quiz-live-products';
  const AUTO_EXCLUDED_HANDLES = new Set([
    'dodatkowy-napis',
    'dodatowe-zdjecie-na-tyl-koszulki',
    'dwie-twarze-bokserki',
    'nadruk-na-calych-bokserkach-przod-tyl',
    'zapakuj-na-prezent',
    'zdjecie-ai'
  ]);

  const FAMILY_LABELS = {
    boxers: 'Bokserki personalizowane',
    shirt: 'Koszulka personalizowana',
    mug: 'Kubek personalizowany',
    panties: 'Majtki personalizowane',
    socks: 'Skarpetki personalizowane',
    pillow: 'Poduszka personalizowana',
    cap: 'Czapka personalizowana',
    tie: 'Krawat personalizowany',
    magnet: 'Magnes personalizowany',
    lighter: 'Zapalniczka personalizowana',
    other: 'Personalizowany prezent'
  };

  const escapeHtml = (value) => String(value == null ? '' : value).replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  })[character]);

  const delay = (milliseconds) => new Promise((resolve) => window.setTimeout(resolve, milliseconds));

  function searchText(value) {
    return String(value == null ? '' : value)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function containsAny(text, terms) {
    return terms.some((term) => text.includes(term));
  }

  function unique(values) {
    return Array.from(new Set(values));
  }

  function inferFamily(text) {
    if (containsAny(text, ['bokser'])) return 'boxers';
    if (containsAny(text, ['majtki', 'figi'])) return 'panties';
    if (containsAny(text, ['skarpet'])) return 'socks';
    if (containsAny(text, ['kubek', 'filiz'])) return 'mug';
    if (containsAny(text, ['poduszk'])) return 'pillow';
    if (containsAny(text, ['czapk'])) return 'cap';
    if (containsAny(text, ['krawat'])) return 'tie';
    if (containsAny(text, ['magnes'])) return 'magnet';
    if (containsAny(text, ['zapalnicz'])) return 'lighter';
    if (containsAny(text, ['bluza', 'hoodie'])) return 'hoodie';
    if (containsAny(text, ['torba', 'bag'])) return 'bag';
    if (containsAny(text, ['koszulk', 't shirt', 'body'])) return 'shirt';
    return 'other';
  }

  function inferMoods(text, family) {
    const moods = ['practical'];
    if (containsAny(text, ['smiesz', 'zabawn', 'beka', 'zart', 'twarz', 'face'])) moods.push('laugh');
    if (containsAny(text, ['love', 'koch', 'serc', 'walent', 'rocznic', 'chlopak', 'dziewczyn', 'maz', 'zona'])) moods.push('romantic');
    if (containsAny(text, ['pamiatk', 'zdjec', 'imion', 'data', 'rodzin', 'mama', 'tata', 'babci', 'dziadk', 'wnuk'])) moods.push('sentimental');
    if (containsAny(text, ['bootleg', 'twarz', 'face', 'caly nadruk']) || ['boxers', 'panties', 'shirt'].includes(family)) moods.push('bold');
    return unique(moods);
  }

  function inferInterests(text) {
    const interests = [];
    if (containsAny(text, ['pupil', 'pies', 'psa', 'kot', 'kota', 'lapk'])) interests.push('petlover');
    if (containsAny(text, ['wedk', 'ryb', 'piw'])) interests.push('fishing_beer');
    if (containsAny(text, ['gaming', 'gamer', 'konsol', 'gra komputer'])) interests.push('gaming');
    if (containsAny(text, ['auto', 'moto', 'samoch'])) interests.push('cars');
    if (containsAny(text, ['majster', 'narzed', 'budow'])) interests.push('diy');
    if (containsAny(text, ['sport', 'pilka', 'rower', 'silown'])) interests.push('sport');
    if (containsAny(text, ['kawa', 'coffee'])) interests.push('coffee');
    if (containsAny(text, ['ogrod', 'kwiat'])) interests.push('garden');
    if (containsAny(text, ['rodzin', 'mama', 'tata', 'babci', 'dziadk', 'dziec', 'wnuk'])) interests.push('family');
    if (containsAny(text, ['beauty', 'uroda', 'styl'])) interests.push('beauty_style');
    if (containsAny(text, ['wyjazd', 'podroz', 'ekipa', 'imprez'])) interests.push('party_travel');
    if (containsAny(text, ['dziec', 'maluch', 'niemowle'])) interests.push('kids_fun');
    return interests.length ? unique(interests) : ['no_preference'];
  }

  function inferSpecificOccasions(text) {
    const occasions = [];
    if (containsAny(text, ['dzien chlopaka'])) occasions.push('boy_day');
    if (containsAny(text, ['walent', 'rocznic'])) occasions.push('valentines');
    if (containsAny(text, ['dzien mamy', 'dzien ojca', 'dzien babci', 'dzien dziadka'])) occasions.push('family_day');
    if (containsAny(text, ['swiet', 'mikolaj', 'choink', 'renifer'])) occasions.push('christmas');
    if (containsAny(text, ['urodzin'])) occasions.push('birthday');
    return unique(occasions);
  }

  function normalizeLiveProduct(source, relationship) {
    if (!source || !source.handle || !source.title || source.available === false) return null;
    const tags = Array.isArray(source.tags) ? source.tags : [];
    const text = searchText([source.title, source.productType, source.handle].concat(tags).join(' '));
    const normalizedTags = tags.map(searchText);
    const family = inferFamily(text);
    const price = Number(source.priceCents || 0) / 100;
    const priceMax = Number(source.priceMaxCents || source.priceCents || 0) / 100;
    if (AUTO_EXCLUDED_HANDLES.has(source.handle)) return null;
    if (normalizedTags.some((tag) => ['quiz wyklucz', 'quiz exclude', 'quiz exclude product'].includes(tag))) return null;
    if (containsAny(text, ['dodatkowy napis', 'dodatkowe zdjecie', 'zapakuj na prezent', 'tym samym wzorem'])) return null;
    if (['hoodie', 'bag'].includes(family) || !source.image || !price) return null;
    return {
      handle: source.handle,
      name: source.title,
      url: source.url || '/products/' + source.handle,
      price: price,
      priceMax: priceMax || price,
      image: source.image,
      available: true,
      liveChecked: true,
      productType: source.productType || '',
      tags: tags,
      publishedAt: source.publishedAt || '',
      recipientSegments: [relationship],
      audiences: [],
      occasions: ['birthday', 'boy_day', 'valentines', 'family_day', 'christmas', 'nooccasion'],
      specificOccasions: inferSpecificOccasions(text),
      moods: inferMoods(text, family),
      interests: inferInterests(text),
      family: family,
      familyLabel: FAMILY_LABELS[family] || FAMILY_LABELS.other,
      combinedSalesUnits: 0,
      combinedSalesRevenue: 0,
      popularity: 0,
      salesTier: 'discovery',
      discoveryCandidate: true,
      autoDiscovered: true,
      baseReason: 'Nowość z kategorii dopasowanej do tej osoby. Personalizacja robi tu cały efekt.'
    };
  }

  function track(event, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: event }, payload || {}));
  }

  function recipientGroupQuestion(answers) {
    const keys = GROUPS_BY_OCCASION[answers.occasion] || GROUPS_BY_OCCASION.birthday;
    return {
      id: 'recipientGroup',
      title: 'Dla kogo ma być ten prezent?',
      subtitle: 'Wybierz osobę lub małą grupę. Nie pokażemy produktów z innej kategorii.',
      options: keys.map((key) => RELATIONSHIPS[key] || GROUP_OPTIONS[key])
    };
  }

  function exactRecipientQuestion(answers) {
    const keys = EXACT_BY_GROUP[answers.recipientGroup];
    if (!keys) return null;
    const titles = {
      partner: 'Dla chłopaka czy dla dziewczyny?',
      family: 'Kto dokładnie dostanie prezent?',
      kids: 'Dla dziecka czy dla niemowlaka?',
      others: 'Kto dokładnie dostanie prezent?'
    };
    return {
      id: 'relationship',
      title: titles[answers.recipientGroup],
      subtitle: 'Ten wybór ustala właściwą kategorię produktów.',
      options: keys.map((key) => RELATIONSHIPS[key])
    };
  }

  function profileQuestion(answers) {
    const keys = PROFILE_KEYS[answers.relationship] || ['shared_story', 'humor'];
    const titles = {
      dad: 'Co najlepiej opisuje Twojego tatę?',
      mom: 'Co najlepiej opisuje Twoją mamę?',
      grandpa: 'Co najlepiej opisuje Twojego dziadka?',
      grandma: 'Co najlepiej opisuje Twoją babcię?',
      child: 'Co najbardziej ucieszy to dziecko?',
      baby: 'Jaki klimat najlepiej pasuje do malucha?',
      partner_male: 'Co najbardziej kręci Twojego chłopaka lub męża?',
      partner_female: 'Co najbardziej lubi Twoja dziewczyna lub żona?'
    };
    return {
      id: 'interest',
      title: titles[answers.relationship] || 'Co najlepiej opisuje tę osobę?',
      subtitle: 'Wybierz jeden najmocniejszy trop.',
      options: keys.map((key) => PROFILE_OPTIONS[key])
    };
  }

  function moodQuestion(answers) {
    const keys = MOOD_KEYS[answers.relationship] || ['laugh', 'sentimental', 'practical'];
    return {
      id: 'mood',
      title: 'Jaką reakcję ma wywołać prezent?',
      subtitle: 'To ostatni wybór. Resztę robimy za Ciebie.',
      options: keys.map((key) => MOOD_OPTIONS[key])
    };
  }

  function questionsFor(answers) {
    const exact = exactRecipientQuestion(answers);
    return [OCCASION, recipientGroupQuestion(answers)].concat(exact ? [exact] : [], [profileQuestion(answers), moodQuestion(answers)]);
  }

  function isDirectRelationship(value) {
    return Boolean(RELATIONSHIPS[value]);
  }

  function relationshipLabel(value) {
    return RELATIONSHIPS[value] ? RELATIONSHIPS[value][2] : 'Wybrana osoba';
  }

  function optionLabel(answers, questionId, value) {
    if (questionId === 'relationship') return relationshipLabel(value);
    const question = questionsFor(answers).find((item) => item.id === questionId);
    const found = question && question.options.find((item) => item[0] === value);
    return found ? found[2] : '';
  }

  function relevanceScore(product, answers) {
    let score = Math.log1p(Number(product.combinedSalesUnits || 0)) * 24;
    score += Math.log1p(Number(product.combinedSalesRevenue || 0)) * 5;
    score += Number(product.popularity || 0) * 10;
    if (Array.isArray(product.occasions) && product.occasions.includes(answers.occasion)) score += 14;
    if (Array.isArray(product.specificOccasions) && product.specificOccasions.includes(answers.occasion)) score += 9;
    if (Array.isArray(product.moods) && product.moods.includes(answers.mood)) score += 12;
    const signals = INTEREST_SIGNALS[answers.interest] || [];
    if (Array.isArray(product.interests) && signals.some((signal) => product.interests.includes(signal))) score += 8;
    return score;
  }

  function seededRandom(seed) {
    let value = (Math.floor(seed * 2147483647) || 1) >>> 0;
    return () => {
      value += 0x6d2b79f5;
      let result = value;
      result = Math.imul(result ^ (result >>> 15), result | 1);
      result ^= result + Math.imul(result ^ (result >>> 7), result | 61);
      return ((result ^ (result >>> 14)) >>> 0) / 4294967296;
    };
  }

  function rankProducts(products, answers, seed, limit) {
    const strict = products
      .filter((product) => Array.isArray(product.recipientSegments) && product.recipientSegments.includes(answers.relationship))
      .map((product) => Object.assign({}, product, { rawScore: relevanceScore(product, answers) }))
      .sort((left, right) => right.rawScore - left.rawScore);

    const pool = strict.slice(0, Math.min(12, strict.length));
    if (pool.length <= limit) return pool;

    const random = seededRandom(seed);
    const firstPool = pool.slice(0, Math.min(3, pool.length));
    const first = firstPool[Math.floor(random() * firstPool.length)];
    const shuffled = pool
      .filter((product) => product.handle !== first.handle)
      .map((product) => ({ product: product, order: random() }))
      .sort((left, right) => left.order - right.order)
      .map((item) => item.product);

    const selected = [first];
    shuffled.forEach((candidate) => {
      if (selected.length >= limit) return;
      const uniqueFamily = !selected.some((product) => product.family === candidate.family);
      const uniqueStillAvailable = shuffled.some((product) =>
        !selected.some((chosen) => chosen.handle === product.handle) &&
        !selected.some((chosen) => chosen.family === product.family)
      );
      if (selected.length < 3 && !uniqueFamily && uniqueStillAvailable) return;
      selected.push(candidate);
    });
    shuffled.forEach((candidate) => {
      if (selected.length < limit && !selected.some((product) => product.handle === candidate.handle)) selected.push(candidate);
    });
    return selected;
  }

  function injectDiscoveryProduct(ranked, discoveries, answers, seed, previousHandles) {
    const selected = ranked.slice();
    const selectedHandles = new Set(selected.map((product) => product.handle));
    const previous = new Set(previousHandles || []);
    const eligible = (discoveries || [])
      .filter((product) =>
        product &&
        product.available !== false &&
        Array.isArray(product.recipientSegments) &&
        product.recipientSegments.includes(answers.relationship) &&
        !selectedHandles.has(product.handle) &&
        !previous.has(product.handle)
      )
      .map((product) => ({ product: product, score: relevanceScore(product, answers) }))
      .sort((left, right) => right.score - left.score);
    if (!eligible.length) return selected;

    const visibleFamilies = new Set(selected.slice(0, 4).map((product) => product.family));
    const varied = eligible.filter((item) => !visibleFamilies.has(item.product.family));
    const pool = (varied.length ? varied : eligible).slice(0, 3);
    const random = seededRandom(Number(seed || 0) + 0.173);
    const discovery = pool[Math.floor(random() * pool.length)].product;
    selected.splice(Math.min(4, selected.length), 0, discovery);
    return selected;
  }

  function resultHeadline(answers) {
    return 'Oto najmocniejsze prezenty dla: ' + relationshipLabel(answers.relationship).toLowerCase() + '.';
  }

  function resultCountCopy(count) {
    if (count === 1) return 'jedną propozycję';
    if (count > 1 && count < 5) return count + ' propozycje';
    return count + ' propozycji';
  }

  class GiftQuiz {
    constructor(root) {
      this.root = root;
      this.root.dataset.egqInitialized = 'true';
      this.catalogUrl = root.dataset.catalogUrl;
      this.shopRoot = root.dataset.shopRoot || '/';
      this.logoUrl = root.dataset.logoUrl || '';
      this.heading = root.dataset.title || 'Znajdź prezent, po którym usłyszysz: „skąd wiedziałaś?”';
      this.mobileHeading = root.dataset.mobileTitle || 'Znajdź prezent, który trafi w punkt';
      this.lead = root.dataset.lead || 'Kilka krótkich wyborów wystarczy, żeby znaleźć do 5 personalizowanych bestsellerów dla właściwej osoby.';
      this.buttonLabel = root.dataset.button || 'Znajdź idealny prezent';
      this.showBadges = root.dataset.showBadges !== 'false';
      this.step = 0;
      this.answers = {};
      this.catalog = [];
      this.baseHandles = new Set();
      this.liveNewByRelationship = {};
      this.liveCatalogRequests = {};
      this.resultSeed = Math.random();
      this.lastHandles = [];
      this.runId = 0;
      this.incomingParams = new URLSearchParams();
      const source = new URLSearchParams(window.location.search);
      source.forEach((value, key) => {
        if (key.startsWith('utm_') || ['fbclid', 'gclid'].includes(key)) this.incomingParams.set(key, value);
      });
      this.init();
    }

    async init() {
      await this.loadCatalog();
      this.renderWelcome();
    }

    route(path) {
      const root = this.shopRoot.endsWith('/') ? this.shopRoot : this.shopRoot + '/';
      return root + String(path || '').replace(/^\//, '');
    }

    scrollTop() {
      this.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    async loadCatalog() {
      try {
        const response = await fetch(this.catalogUrl, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('catalog');
        const payload = await response.json();
        if (!payload || !Array.isArray(payload.products) || !payload.products.length) throw new Error('empty');
        this.catalog = payload.products;
        this.baseHandles = new Set(this.catalog.map((product) => product.handle));
      } catch (error) {
        this.catalog = [];
        this.baseHandles = new Set();
      }
    }

    async fetchLiveProducts(relationship) {
      const collection = COLLECTIONS[relationship];
      if (!collection) return [];
      const separator = collection[1].includes('?') ? '&' : '?';
      const url = this.route(collection[1]) + separator + 'section_id=' + LIVE_PRODUCTS_SECTION;
      const response = await fetch(url, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'text/html' }
      });
      if (!response.ok) throw new Error('live-products');
      const html = await response.text();
      const match = html.match(/<script[^>]*data-egq-live-products[^>]*>([\s\S]*?)<\/script>/i);
      if (!match) throw new Error('live-products-json');
      const payload = JSON.parse(match[1]);
      if (!payload || !Array.isArray(payload.products)) throw new Error('live-products-empty');
      const seen = new Set();
      const products = payload.products
        .map((product) => normalizeLiveProduct(product, relationship))
        .filter((product) => {
          if (!product || this.baseHandles.has(product.handle) || seen.has(product.handle)) return false;
          seen.add(product.handle);
          return true;
        })
        .sort((left, right) => String(right.publishedAt || '').localeCompare(String(left.publishedAt || '')));
      this.liveNewByRelationship[relationship] = products;
      return products;
    }

    prefetchLiveProducts(relationship) {
      if (!relationship) return Promise.resolve([]);
      if (!this.liveCatalogRequests[relationship]) {
        this.liveCatalogRequests[relationship] = this.fetchLiveProducts(relationship).catch(() => {
          this.liveNewByRelationship[relationship] = [];
          return [];
        });
      }
      return this.liveCatalogRequests[relationship];
    }

    brand(compact) {
      const content = this.logoUrl
        ? '<img class="egq__logo" src="' + escapeHtml(this.logoUrl) + '" alt="E-Gifts">'
        : '<strong class="egq__logo-fallback">E-GIFTS</strong>';
      return '<a class="egq__brand' + (compact ? ' egq__brand--compact' : '') + '" href="' + escapeHtml(this.route()) + '" aria-label="E-Gifts, strona główna">' + content + '</a>';
    }

    quizActions() {
      return '<div class="egq__quiz-actions">' +
        '<button type="button" data-egq-restart-top>↻ Od nowa</button>' +
        '<a href="' + escapeHtml(this.route()) + '">Wyjdź do sklepu</a>' +
      '</div>';
    }

    bindQuizActions() {
      this.root.querySelectorAll('[data-egq-restart-top]').forEach((button) => {
        button.addEventListener('click', () => this.restartQuiz());
      });
    }

    showcase() {
      const preferred = ['zabawne-bokserki-z-twarza-calus', 'koszulka-bootleg-personalizowana', 'personalizowane-skarpetki-z-pupilem-kolorowe-lapki'];
      const products = preferred.map((handle) => this.catalog.find((product) => product.handle === handle)).filter(Boolean);
      this.catalog.forEach((product) => {
        if (products.length < 3 && !products.some((item) => item.handle === product.handle) && !products.some((item) => item.family === product.family)) products.push(product);
      });
      return products.slice(0, 3);
    }

    renderWelcome() {
      this.runId += 1;
      const captions = ['Prezent, który robi efekt', 'Wasze zdjęcie, Wasz tekst', 'Pomysł dobrany do osoby'];
      const cards = this.showcase().map((product, index) =>
        '<figure class="egq__collage-card egq__collage-card--' + (index + 1) + '">' +
          '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.name) + '">' +
          '<figcaption>' + captions[index] + '</figcaption>' +
        '</figure>'
      ).join('');
      this.root.innerHTML =
        '<div class="egq__shell">' +
          '<header class="egq__header">' + this.brand(false) + '<div class="egq__header-proof"><span>♥</span> Personalizowane prezenty z emocją</div></header>' +
          '<section class="egq__welcome" aria-labelledby="egq-welcome-title">' +
            '<div class="egq__welcome-copy">' +
              '<div class="egq__eyebrow"><span>♥</span> Prezentownik E-Gifts</div>' +
              '<h1 id="egq-welcome-title"><span class="egq__title-desktop">' + escapeHtml(this.heading) + '</span><span class="egq__title-mobile">' + escapeHtml(this.mobileHeading) + '</span></h1>' +
              '<p class="egq__lead">' + escapeHtml(this.lead) + '</p>' +
              '<div class="egq__actions">' +
                '<button class="egq__primary" type="button" data-egq-start>' + escapeHtml(this.buttonLabel) + ' <b aria-hidden="true">→</b></button>' +
                '<p class="egq__micro"><span>✓</span> około 30 sekund, bez rejestracji, od razu konkretne pomysły</p>' +
              '</div>' +
              '<div class="egq__trust"><span><i>♥</i> Dopasowanie do osoby</span><span><i>☺</i> Humor i prawdziwe emocje</span><span><i>✦</i> Gotowe pomysły do personalizacji</span></div>' +
            '</div>' +
            '<div class="egq__collage" aria-label="Przykładowe personalizowane produkty E-Gifts">' +
              '<div class="egq__collage-blob" aria-hidden="true"></div>' + cards +
              '<div class="egq__collage-note"><b>TOP 5</b><small>pomysłów<br>dla Ciebie</small></div>' +
            '</div>' +
          '</section>' +
          '<div class="egq__steps"><div><span>1</span> Wybierasz okazję</div><i>→</i><div><span>2</span> Opowiadasz o osobie</div><i>→</i><div><span>3</span> Dostajesz do 5 propozycji</div></div>' +
        '</div>';
      this.root.querySelector('[data-egq-start]').addEventListener('click', () => this.start());
    }

    start() {
      this.runId += 1;
      this.step = 0;
      this.answers = {};
      this.resultSeed = Math.random();
      this.lastHandles = [];
      track('gift_quiz_start', { placement: 'shopify' });
      this.renderQuestion();
      this.scrollTop();
    }

    restartQuiz() {
      this.runId += 1;
      this.step = 0;
      this.answers = {};
      this.resultSeed = Math.random();
      this.lastHandles = [];
      this.renderQuestion();
      this.scrollTop();
    }

    renderQuestion() {
      const questions = questionsFor(this.answers);
      const question = questions[this.step];
      const progress = ((this.step + 1) / questions.length) * 100;
      const insight = this.step >= 2 && this.answers.relationship
        ? '<div class="egq__insight"><span>♥</span> Szukamy prezentu: ' + escapeHtml(relationshipLabel(this.answers.relationship).toLowerCase()) + '</div>'
        : '';
      const options = question.options.map((item) =>
        '<button class="egq__option" type="button" data-egq-answer="' + escapeHtml(item[0]) + '">' +
          '<span class="egq__option-icon" aria-hidden="true">' + escapeHtml(item[1]) + '</span>' +
          '<span class="egq__option-copy"><strong>' + escapeHtml(item[2]) + '</strong><small>' + escapeHtml(item[3]) + '</small></span>' +
          '<span class="egq__option-arrow" aria-hidden="true">→</span>' +
        '</button>'
      ).join('');
      this.root.innerHTML =
        '<div class="egq__quiz">' +
          '<header class="egq__quiz-top">' +
            '<div class="egq__quiz-left"><button class="egq__back" type="button" data-egq-back aria-label="Wróć">←</button><span class="egq__step-count">' + (this.step + 1) + ' / ' + questions.length + '</span></div>' +
            this.brand(true) + this.quizActions() +
          '</header>' +
          '<div class="egq__progress"><span style="width:' + progress + '%"></span></div>' +
          '<section class="egq__question" aria-labelledby="egq-question-title">' +
            insight + '<p class="egq__kicker">Pytanie ' + (this.step + 1) + ' z ' + questions.length + '</p>' +
            '<h2 id="egq-question-title">' + escapeHtml(question.title) + '</h2>' +
            '<p class="egq__subtitle">' + escapeHtml(question.subtitle) + '</p>' +
            '<div class="egq__options">' + options + '</div>' +
            '<p class="egq__promise"><span>✓</span> Na końcu pokażemy do 5 bestsellerów tylko z właściwej kategorii.</p>' +
          '</section>' +
        '</div>';
      this.root.querySelector('[data-egq-back]').addEventListener('click', () => this.goBack());
      this.root.querySelectorAll('[data-egq-answer]').forEach((button) => button.addEventListener('click', () => this.choose(button)));
      this.bindQuizActions();
    }

    choose(button) {
      if (button.classList.contains('is-selected')) return;
      const questions = questionsFor(this.answers);
      const question = questions[this.step];
      const value = button.dataset.egqAnswer;
      button.classList.add('is-selected');
      button.querySelector('.egq__option-arrow').textContent = '✓';
      const nextAnswers = Object.assign({}, this.answers, { [question.id]: value });
      if (question.id === 'occasion') {
        delete nextAnswers.recipientGroup;
        delete nextAnswers.relationship;
        delete nextAnswers.interest;
        delete nextAnswers.mood;
      } else if (question.id === 'recipientGroup') {
        delete nextAnswers.relationship;
        delete nextAnswers.interest;
        delete nextAnswers.mood;
        if (isDirectRelationship(value)) nextAnswers.relationship = value;
      } else if (question.id === 'relationship') {
        delete nextAnswers.interest;
        delete nextAnswers.mood;
      } else if (question.id === 'interest') {
        delete nextAnswers.mood;
      }
      this.answers = nextAnswers;
      if (this.answers.relationship) this.prefetchLiveProducts(this.answers.relationship);
      track('gift_quiz_answer', { question: question.id, answer: value, step: this.step + 1, total_steps: questions.length });
      window.setTimeout(() => {
        if (this.step < questions.length - 1) {
          this.step += 1;
          this.renderQuestion();
          this.scrollTop();
        } else {
          this.analyze();
        }
      }, 220);
    }

    goBack() {
      if (this.step === 0) this.renderWelcome();
      else {
        this.step -= 1;
        this.renderQuestion();
      }
      this.scrollTop();
    }

    async analyze() {
      const runId = this.runId;
      const liveProductsPromise = this.prefetchLiveProducts(this.answers.relationship);
      this.root.innerHTML =
        '<div class="egq__analysis">' +
          '<header class="egq__analysis-top">' + this.brand(true) + this.quizActions() + '</header>' +
          '<section class="egq__analysis-card" aria-live="polite">' +
            '<div class="egq__analysis-heart">♥</div><p class="egq__kicker">Już prawie gotowe</p>' +
            '<h2>Wybieramy najlepsze prezenty...</h2>' +
            '<p>Sprawdzamy właściwą kategorię i wybieramy jej najmocniejsze propozycje.</p>' +
            '<div class="egq__analysis-list">' +
              '<div data-stage="1"><span>1</span> Właściwa osoba i kategoria</div>' +
              '<div data-stage="2"><span>2</span> Okazja i Wasz klimat</div>' +
              '<div data-stage="3"><span>3</span> Najmocniejsze bestsellery dla tej osoby</div>' +
            '</div>' +
          '</section>' +
        '</div>';
      this.bindQuizActions();
      this.scrollTop();
      for (let stage = 1; stage <= 3; stage += 1) {
        await delay(360);
        if (runId !== this.runId) return;
        const row = this.root.querySelector('[data-stage="' + stage + '"]');
        if (row) {
          row.classList.add('is-done');
          row.querySelector('span').textContent = '✓';
        }
      }
      await delay(180);
      await Promise.race([liveProductsPromise, delay(900)]);
      if (runId !== this.runId) return;
      this.renderResults(runId, true);
    }

    async hydrateProduct(product) {
      try {
        const response = await fetch(this.route('products/' + product.handle + '.js'), { credentials: 'same-origin' });
        if (!response.ok) {
          if (response.status === 404) return Object.assign({}, product, { available: false, liveChecked: true });
          throw new Error('product');
        }
        const live = await response.json();
        const prices = Array.isArray(live.variants)
          ? live.variants.map((variant) => Number(variant.price || 0) / 100).filter(Boolean)
          : [];
        return Object.assign({}, product, {
          name: live.title || product.name,
          price: prices.length ? Math.min.apply(null, prices) : product.price,
          priceMax: prices.length ? Math.max.apply(null, prices) : product.priceMax,
          image: live.featured_image || product.image,
          available: Boolean(live.available),
          liveChecked: true
        });
      } catch (error) {
        return Object.assign({}, product, { available: null, liveChecked: false });
      }
    }

    priceLabel(product) {
      const formatter = new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' });
      return Number(product.priceMax || 0) > Number(product.price || 0)
        ? 'od ' + formatter.format(product.price)
        : formatter.format(product.price);
    }

    badge(product) {
      if (product.salesTier === 'bestseller') return ['bestseller', 'Bestseller E-Gifts'];
      if (product.autoDiscovered) return ['discovery', 'Nowość E-Gifts'];
      if (product.discoveryCandidate) return ['discovery', 'Mocny typ w tej kategorii'];
      return ['proven', 'Dobry wybór'];
    }

    reason(product) {
      const moods = {
        laugh: 'Ma duży potencjał na śmiech już przy otwieraniu.',
        romantic: 'Dobrze pasuje do osobistego prezentu dla bliskiej osoby.',
        sentimental: 'Może zamienić ważne wspomnienie w prezent na dłużej.',
        practical: 'Łączy personalizację z czymś, czego można naprawdę używać.',
        bold: 'Ma mocny nadruk i od razu przyciąga uwagę.'
      };
      return ((product.baseReason || '') + ' ' + (moods[this.answers.mood] || '')).trim();
    }

    outbound(product) {
      const params = new URLSearchParams(this.incomingParams);
      params.set('quiz_source', 'prezentownik');
      params.set('quiz_relationship', this.answers.relationship || 'unknown');
      params.set('quiz_occasion', this.answers.occasion || 'unknown');
      const separator = String(product.url || '').includes('?') ? '&' : '?';
      return String(product.url || this.route('products/' + product.handle)) + separator + params.toString();
    }

    productBadge(product) {
      if (!this.showBadges) return '';
      const badge = this.badge(product);
      return '<span class="egq__sales-badge egq__sales-badge--' + badge[0] + '">' + badge[1] + '</span>';
    }

    productCard(product, index, primary) {
      const availability = product.liveChecked
        ? product.available
          ? '<span class="egq__available">Dostępny</span>'
          : '<span class="egq__unavailable">Sprawdź dostępność</span>'
        : '';
      const rank = primary ? 'Najlepszy wybór' : 'Pomysł ' + (index + 1);
      const explanation = primary
        ? '<div class="egq__why"><strong>Dlaczego warto?</strong><p>' + escapeHtml(this.reason(product)) + '</p></div>'
        : '<p class="egq__reason">' + escapeHtml(this.reason(product)) + '</p>';
      return '<article class="' + (primary ? 'egq__primary-product' : 'egq__secondary-product') + '">' +
        '<div class="' + (primary ? 'egq__primary-media' : 'egq__secondary-media') + '">' +
          '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.name) + '" loading="' + (primary ? 'eager' : 'lazy') + '">' +
          '<span class="egq__rank">' + rank + '</span>' +
        '</div>' +
        '<div class="' + (primary ? 'egq__primary-copy' : 'egq__secondary-copy') + '">' +
          this.productBadge(product) +
          '<p class="egq__category">' + escapeHtml(product.familyLabel) + '</p>' +
          '<h3>' + escapeHtml(product.name) + '</h3>' +
          explanation +
          '<div class="egq__product-footer"><div><small>Cena</small><strong>' + escapeHtml(this.priceLabel(product)) + '</strong>' + availability + '</div>' +
            '<a class="egq__product-cta" href="' + escapeHtml(this.outbound(product)) + '" data-egq-product-click="' + escapeHtml(product.handle) + '" data-position="' + (index + 1) + '">Zobacz i spersonalizuj <span>→</span></a>' +
          '</div>' +
        '</div>' +
      '</article>';
    }

    collection() {
      return COLLECTIONS[this.answers.relationship] || ['Zobacz wszystkie bestsellery', 'collections/bestsellery'];
    }

    renderError() {
      const collection = this.collection();
      this.root.innerHTML =
        '<div class="egq__results">' +
          '<header class="egq__header egq__results-top">' + this.brand(true) + this.quizActions() + '</header>' +
          '<div class="egq__error"><strong>Prezenty chwilowo się nie wczytały.</strong>' +
            '<p>Odśwież stronę albo przejdź prosto do właściwej kategorii.</p>' +
            '<a href="' + escapeHtml(this.route(collection[1])) + '">' + escapeHtml(collection[0]) + ' →</a>' +
          '</div>' +
        '</div>';
      this.bindQuizActions();
    }

    async renderResults(runId, trackComplete) {
      if (!this.catalog.length) {
        this.renderError();
        return;
      }

      let ranked = rankProducts(this.catalog, this.answers, this.resultSeed, 10);
      if (this.lastHandles.length) {
        const unseen = ranked.filter((product) => !this.lastHandles.includes(product.handle));
        const alreadyShown = ranked.filter((product) => this.lastHandles.includes(product.handle));
        ranked = unseen.concat(alreadyShown);
      }
      const liveProducts = this.liveNewByRelationship[this.answers.relationship] || [];
      ranked = injectDiscoveryProduct(ranked, liveProducts, this.answers, this.resultSeed, this.lastHandles).slice(0, 10);

      if (!ranked.length) {
        this.renderError();
        return;
      }

      const hydrated = await Promise.all(ranked.map((product) => this.hydrateProduct(product)));
      if (runId !== this.runId) return;
      const products = hydrated.filter((product) => product.available !== false).slice(0, 5);
      if (!products.length) {
        this.renderError();
        return;
      }
      this.lastHandles = products.map((product) => product.handle);

      const chips = ['relationship', 'occasion', 'interest', 'mood']
        .map((id) => optionLabel(this.answers, id, this.answers[id]))
        .filter(Boolean)
        .map((label) => '<span>' + escapeHtml(label) + '</span>')
        .join('');
      const collection = this.collection();
      const strictCount = this.catalog.filter((product) =>
        Array.isArray(product.recipientSegments) && product.recipientSegments.includes(this.answers.relationship)
      ).length + liveProducts.length;
      const shuffle = strictCount > products.length
        ? '<button class="egq__shuffle" type="button" data-egq-shuffle>↻ Pokaż inne bestsellery</button>'
        : '';

      this.root.innerHTML =
        '<div class="egq__results">' +
          '<header class="egq__header egq__results-top">' + this.brand(true) + this.quizActions() + '</header>' +
          '<section class="egq__results-hero"><div class="egq__result-heart">♥</div><p class="egq__kicker">Mamy to</p>' +
            '<h2>' + escapeHtml(resultHeadline(this.answers)) + '</h2>' +
            '<p>Wybraliśmy ' + escapeHtml(resultCountCopy(products.length)) + ' tylko z kategorii właściwej dla tej osoby.</p>' +
            '<div class="egq__chips">' + chips + '</div>' +
          '</section>' +
          '<section class="egq__recommendations">' +
            '<div class="egq__section-heading"><div><p class="egq__kicker">Wybrane specjalnie dla Ciebie</p><h2>Twoje TOP ' + products.length + '</h2></div>' +
            '<p>Quiz wybrał produkty za Ciebie. Teraz wybierz ten, który wywoła najlepszą reakcję.</p></div>' +
            this.productCard(products[0], 0, true) +
            '<div class="egq__secondary-grid">' + products.slice(1).map((product, index) => this.productCard(product, index + 1, false)).join('') + '</div>' +
            '<div class="egq__result-actions">' + shuffle +
              '<a class="egq__collection-cta" href="' + escapeHtml(this.route(collection[1])) + '">' + escapeHtml(collection[0]) + ' <span>→</span></a>' +
            '</div>' +
          '</section>' +
          '<section class="egq__principles">' +
            '<div><span>♥</span><strong>Prezent po Waszemu</strong><small>Zdjęcie, imiona lub tekst, który znacie tylko Wy.</small></div>' +
            '<div><span>☺</span><strong>Efekt przy otwieraniu</strong><small>Śmiech, wzruszenie albo jedno wielkie WOW.</small></div>' +
            '<div><span>✓</span><strong>Od razu do konkretu</strong><small>Każdy pomysł prowadzi prosto do personalizacji.</small></div>' +
          '</section>' +
        '</div>';

      this.bindQuizActions();
      const shuffleButton = this.root.querySelector('[data-egq-shuffle]');
      if (shuffleButton) {
        shuffleButton.addEventListener('click', () => {
          shuffleButton.disabled = true;
          shuffleButton.classList.add('is-loading');
          shuffleButton.textContent = 'Szukamy kolejnych...';
          this.runId += 1;
          this.resultSeed = Math.random();
          this.renderResults(this.runId, false);
        });
      }
      this.root.querySelectorAll('[data-egq-product-click]').forEach((link) => link.addEventListener('click', () => {
        track('gift_quiz_product_click', {
          product: link.dataset.egqProductClick,
          position: Number(link.dataset.position)
        });
      }));
      if (trackComplete) {
        track('gift_quiz_complete', {
          relationship: this.answers.relationship,
          occasion: this.answers.occasion,
          mood: this.answers.mood,
          top_product: products[0] ? products[0].handle : ''
        });
      }
      if (trackComplete) {
        this.scrollTop();
      } else {
        const recommendations = this.root.querySelector('.egq__recommendations');
        if (recommendations) recommendations.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  document.querySelectorAll('[data-egq-root]:not([data-egq-initialized])').forEach((root) => new GiftQuiz(root));
})();